// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"79b7705e","598":"4ca3fa06","703":"e473751a"}[chunkId] + ".chunk.js";
};